module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.0b76306.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/font/roboto/Roboto-Medium.otf
// module id = gJlV
// module chunks = 0